
// 弹窗类型优先级队列， 队列的顺序决定了弹窗的显示优先级
import {withBase} from '@/utils/basePath';

export const POP_TYPE_RANK = [
    // 【智能体强引导入口下线一期】PRD3/PRD9：智能体相关弹窗的入队逻辑已在
    // law-header.vue 与 consult/index.vue 中注释，此处保留优先级配置项不动，
    // 避免影响其余弹窗（traffic-boost / free-vip / ui-carousel）的相对顺序。
    // 恢复时只需恢复上述两处入队逻辑。
    'claim-agent-modal',
    // 'agent-create-dialog-new',
    'traffic-boost-dialog',
    'agent-create-dialog',
    'free-vip-dialog',
    'ui-carousel'
];

export const POP_PAGE_NEED_SPECIAL_TASK_MAP = {
    [withBase('/consult')]: true
};

export const POP_PAGE_NEED_SPECIAL_TASK_ROUTE_MAP = {
    '/consult': true
};
